import { Dialog, DialogContent, DialogTitle, Switch } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { EditButton, ShowButton, useDataGrid } from "@refinedev/mui";
import { List } from "pages/in-stock/components/List";
import React, { useState } from "react";
import { ContainerCreate } from "./create";

export const ContainerList = () => {
  const { dataGridProps } = useDataGrid();
  const [open, setOpen] = useState<boolean>(false);
  const onClose = () => {
    setOpen(false);
  };

  const columns = React.useMemo<GridColDef<any>[]>(
    () => [
      {
        field: "name",
        headerName: "Name",
        type: "string",
        minWidth: 200,
      },
      {
        field: "type",
        headerName: "Type",
        minWidth: 200,
      },
      {
        field: "is_used",
        headerName: "Is Used",
        minWidth: 250,
        renderCell: function render({ value }) {
          return <Switch checked={!!value} />;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    []
  );

  return (
    <List open={open} setOpen={setOpen}>
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>Create Client</DialogTitle>
        <DialogContent>
          <ContainerCreate onClose={onClose} />
        </DialogContent>
      </Dialog>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
